import { NavLink, NavLinkProps } from "remix";

export function NavigationLink(props: NavLinkProps) {
  return (
    <NavLink
      className={({ isActive }) =>
        isActive
          ? "flex items-center font-bold text-md text-white border-y-4 border-t-transparent border-b-primary-50 py-1 md:py-3 px-3 text-sm md:text-md"
          : "flex items-center font-bold text-md text-primary-50 border-y-4 border-t-transparent border-transparent py-1 md:py-3 px-3 text-sm md:text-md hover:text-white hover:border-b-primary-100"
      }
      {...props}
    />
  );
}
